import BeerCard from './BeerCard';
export default BeerCard;
